import React, { useEffect } from 'react'
import dynamic from 'next/dynamic'

import { useBlockWindowOverflow } from 'app/hooks'

const BaseTour = dynamic(() => import('../BaseTour'), { ssr: false })

const SimpleTourWrapper = props => {
  if (props.isOpen) {
    return <SimpleTour {...props} />
  }

  return null
}

const SimpleTour = props => {
  useBlockWindowOverflow(props.isOpen)

  const steps = props.steps.map(step => ({
    ...step,
    style: {
      width: '20rem',
      ...step.style
    }
  }))

  return <BaseTour {...props} steps={steps} />
}

SimpleTour.defaultProps = {
  steps: []
}

export default SimpleTourWrapper
